import React from 'react';
import './RangeSelectionButton.scss';

export default function RangeSelectionButton({ active, onClick }) {
  return <button
    type="button"
    className={`range-selection-button${active ? ' range-selection-button-active' : ''}`}
    aria-pressed={active}
    aria-label="Range mode: tap the first and last checkboxes"
    title="Tap Range, then tap the first and last checkboxes to select or clear a group. You can also Shift-click."
    onClick={onClick}
  >
    {active ? 'Range on' : 'Range'}
  </button>;
}
